"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchFilter = void 0;
var core_1 = require("@material-ui/core");
var react_1 = __importDefault(require("react"));
var SvgIcon_1 = require("../SvgIcon");
exports.SearchFilter = function (_a) {
    var _b;
    var sections = _a.sections;
    return (react_1.default.createElement("div", { className: "search-filter-wrapper" },
        (sections === null || sections === void 0 ? void 0 : sections.searchInput) && (react_1.default.createElement(core_1.TextField, __assign({}, sections === null || sections === void 0 ? void 0 : sections.searchInput.props, { fullWidth: true, id: "filled-start-adornment", InputProps: {
                placeholder: 'Search',
                disableUnderline: true,
                endAdornment: (react_1.default.createElement(core_1.InputAdornment, { position: "end" },
                    react_1.default.createElement(SvgIcon_1.Search, null))),
            }, variant: "filled" }))),
        react_1.default.createElement(core_1.Grid, { justify: "flex-start", container: true, className: "date-section m-b-14" },
            react_1.default.createElement(core_1.Grid, { xs: 6, item: true, className: "p-r-10" },
                react_1.default.createElement("div", __assign({ className: "date-picker" }, sections === null || sections === void 0 ? void 0 : sections.checkInDate.props),
                    react_1.default.createElement("div", { className: "date-value flex-space" },
                        react_1.default.createElement("div", { className: "desc m-b-4" }, "Check In"),
                        react_1.default.createElement("div", { className: "fs-14 fw-600" },
                            " ", sections === null || sections === void 0 ? void 0 :
                            sections.checkInDate.value)),
                    react_1.default.createElement(SvgIcon_1.CheckInOutDate, null))),
            react_1.default.createElement(core_1.Grid, { xs: 6, item: true, className: "p-l-10" },
                react_1.default.createElement("div", __assign({ className: "date-picker" }, sections === null || sections === void 0 ? void 0 : sections.checkOutDate.props),
                    react_1.default.createElement("div", { className: "date-value flex-space" },
                        react_1.default.createElement("div", { className: "desc m-b-4" }, "Check Out"),
                        react_1.default.createElement("div", { className: "fs-14 fw-600" },
                            ' ', sections === null || sections === void 0 ? void 0 :
                            sections.checkOutDate.value)),
                    react_1.default.createElement(SvgIcon_1.CheckInOutDate, null)))),
        react_1.default.createElement(core_1.Grid, { justify: "flex-start", container: true, className: "filter-section m-b-14" },
            react_1.default.createElement(core_1.Grid, { xs: 6, item: true, className: "p-r-10" },
                react_1.default.createElement("div", __assign({ className: "adult-selection" }, sections === null || sections === void 0 ? void 0 : sections.filter.props),
                    react_1.default.createElement("div", { className: "value flex-space" },
                        react_1.default.createElement("div", { className: "fs-14 fw-600" }, ((_b = sections === null || sections === void 0 ? void 0 : sections.filter) === null || _b === void 0 ? void 0 : _b.value) || 'Adult')),
                    react_1.default.createElement(SvgIcon_1.Person, null))),
            react_1.default.createElement(core_1.Grid, { xs: 6, item: true, className: "p-l-10" },
                react_1.default.createElement(core_1.Button, __assign({}, sections === null || sections === void 0 ? void 0 : sections.searchButton.props, { variant: "contained", color: "primary", fullWidth: true, className: "search-btn" }), "Search")))));
};
//# sourceMappingURL=SearchFilter.js.map